import { Link } from "react-router-dom";

const EmptyCart = () => {
    return (
        <div className="container-indent nomargin">
            <div className="tt-empty-cart">
                <span className="tt-icon icon-f-39" />
                <h1 className="tt-title">SHOPPING CART IS EMPTY</h1>
                <p>You have no items in your shopping cart.</p>
                <div className="mt-5"><Link to="/deals" className="p-link ">CONTINUE SHOPPING</Link></div>
            </div>
        </div>
    );
};

export default EmptyCart;